<template>
    <div class="lg:p-10" :class="{'-mx-4 lg:mx-0': currentPage > 1, 'px-5': currentPage === 1, 'ffq-sidebar__spacing': personalizedImage && currentPage > 1, '-mt-5': !personalizedImage &&  answers.length === 0 && currentPage > 1}" :style="{'background-image': (personalizedImage && currentPage > 1 ) ? 'url(' + personalizedImage + ')' : ''}">
        <div v-if="currentPage === 1" class="flex flex-col justify-center">
            <div class="flex items-center justify-center">
                <img v-if="logos.dark" :src="logos.dark" class="max-w-sm w-full" />
            </div>
            <div v-if="logos.dark" class="h-1 border-t-2 my-4 | ffq-sidebar-divider | lg:border-gray-300"/>
            <div v-html="quizDescription" class="hidden md:block">

            </div>
            <div v-html="quizMobileDescription" class="md:hidden">

            </div>
        </div>
        <div v-if="currentPage > 1 && answers.length > 0" class="ffq-sidebar--answers | flex flex-row flex-nowrap overflow-x-auto bg-gray-100 items-center | lg:pt-0 lg:flex-col lg:flex-wrap lg:overflow-auto lg:bg-transparent lg:items-stretch">
            <div class="whitespace-nowrap ml-2 text-xs lg:hidden">
                Uw keuzes:
            </div>
            <div v-for="answer in answers" class="ffq-sidebar--answers--block | animated fadeIn">
                <img src="/plugins/wallbrinkcrossmedia/flitzfunnelquizzes/assets/images/svg-vink.svg"/>
                <div>
                    <div class="text-xs text-gray-400 hidden lg:block">{{ answer.question }}</div>
                    {{ answer.answer }}
                </div>
            </div>
        </div>
        <div v-if="currentPage === lastPage" class="hidden lg:flex lg:justify-center lg:mt-4">
            <div class="ffq-sidebar--answers--finished-check | animated bounceIn" style="--animate-delay: 1s;">
                <img src="/plugins/wallbrinkcrossmedia/flitzfunnelquizzes/assets/images/svg-vink.svg"/>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
@import "~animate.css/source/_vars";
@import "~animate.css/source/_base";
@import "~animate.css/source/bouncing_entrances/bounceIn";
@import "~animate.css/source/fading_entrances/fadeIn";

.ffq-sidebar{
    &__spacing{
        padding-top:100px;
        @media (min-width: 1024px) {
            @apply p-10;
        }
    }
    &--answers{
        min-height: 40px;

        @media (min-width: 1024px) {
            min-height: auto;
        }

        &--block{
            @apply rounded-md border-gray-500 bg-white px-2 m-2 shadow-md font-thin whitespace-nowrap lg:font-normal lg:p-3 lg:h-auto lg:whitespace-normal;
            @apply flex flex-shrink-0;
            @media (min-width: 1024px) {
                @apply flex-grow flex-shrink;
            }

            img{
                @apply pr-2 w-5;

                @media (min-width: 1024px) {
                    @apply pr-3;
                    width: 34px;
                }
            }
        }

        &--finished-check{
            @apply  w-14 h-14 bg-white flex justify-center items-center rounded-full shadow-md;
        }
    }
}

</style>
<script>
import { useStore } from 'vuex'
import {computed} from "vue";

export default {
    name: "SideBar",
    components:{

    },
    data() {
        return {

        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()
        return {
            currentPage: computed(() => store.state.currentPageNumber),
            lastPage: computed(() => store.state.totalPageCount),
            quizDescription: computed(() => store.getters.quizDescription),
            quizMobileDescription: computed(() => store.getters.quizMobileDescription),
            answers: computed(() => store.getters.readableSubmittedAnswers),
            logos: computed(() => store.state.quizData.style.logos),
            personalizedImage: computed(() => store.state.personalizedValues.image),
        }
    },
    methods:{

    },
    props: {

    }
}
</script>
